export default "__VITE_ASSET__Simxb00a__"